// extracted by mini-css-extract-plugin
module.exports = {"container":"CreditOffer_container__uc9s6","message":"CreditOffer_message__UWwmC"};